import { useEffect, useRef, useState } from "react";

const TAB_KEY = "single_tab_active";
const HEARTBEAT = 2000;

export default function useSingleTab() {
  const tabId = useRef(`${Date.now()}-${Math.random()}`);
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    const claimLock = () => {
      const data = localStorage.getItem(TAB_KEY);

      if (data) {
        const { id, ts } = JSON.parse(data);

        if (id !== tabId.current && Date.now() - ts < HEARTBEAT * 2) {
          setBlocked(true);
          return false;
        }
      }

      localStorage.setItem(
        TAB_KEY,
        JSON.stringify({ id: tabId.current, ts: Date.now() })
      );
      return true;
    };

    if (!claimLock()) return;

    const interval = setInterval(claimLock, HEARTBEAT);

    const onStorage = (e) => {
      if (e.key === TAB_KEY) {
        const { id } = JSON.parse(e.newValue || "{}");
        if (id !== tabId.current) {
          setBlocked(true);
        }
      }
    };

    const cleanup = () => {
      const data = localStorage.getItem(TAB_KEY);
      if (data && JSON.parse(data).id === tabId.current) {
        localStorage.removeItem(TAB_KEY);
      }
    };

    window.addEventListener("storage", onStorage);
    window.addEventListener("beforeunload", cleanup);

    return () => {
      clearInterval(interval);
      cleanup();
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("beforeunload", cleanup);
    };
  }, []);

  return blocked;
}
